import { axiosInstance } from "../../serviceConf";

export function clientList(
  page,
  pagesize,
  fechainicio,
  fechafinal,
  ambiente,
  estado,
  campoBusqueda,
  busqueda
) {
  let url = `b2b/clienteInfo`;
  let params = {
    page: page,
    pageSize: pagesize,
    fechaInicio: fechainicio,
    fechaFin: fechafinal,
    ambiente: ambiente,
    tipo: "Lista",
    ...(estado && {
      estado: estado,
    }),
    ...(campoBusqueda && {
      campoBusqueda: campoBusqueda,
    }),
    ...(busqueda && {
      busqueda: busqueda,
    }),
  };
  return new Promise((resolve, reject) =>
    axiosInstance
      .get(url, { params })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      })
  );
}
